import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children }) => (
  <div className="flex items-center gap-4 mb-8">
    {index && <span className="font-oswald text-[#E85A24] text-sm tracking-[0.3em]">{index}</span>}
    <span className="h-px w-10 bg-[#E85A24]" />
    <span className="font-oswald uppercase tracking-[0.3em] text-xs md:text-sm text-[#A3A3A3]">
      {children}
    </span>
  </div>
);
